import { memo } from "react";
import LogRocket from "logrocket";
import { EDDM_SIGNUP } from "shared/constants";
import CONFIG from "config/config";
import { authorization } from "module/auth";
import { useQuery } from "react-query";
import { getClient } from "../../graphQL";
import { loadGTM } from "../../loadGTM";
import Login from "./components/login";
import { authorize } from "./utils";

const Auth = ({ children }) => {
  // Public routes bypass the "must be logged in or show <Login />" gate.
  //   - `/design/...`   the guest builder itself (anonymous editing).
  //   - `/auth/social/` the OAuth handover landings (`/auth/social/signup`
  //                     and `/auth/social/callback`). These render inside
  //                     the popup window opened by SignupModal AFTER
  //                     Google but BEFORE the user is logged in — gating
  //                     them was the bug that made the guest OAuth signup
  //                     hand-over silently no-op: the Auth wrapper
  //                     short-circuited to <Login /> and OAuthHandover
  //                     never mounted, so neither the localStorage write
  //                     nor the postMessage to the opener ever fired.
  const path = window.location.pathname;
  const isPublicRoute = path.startsWith("/design/") || path.startsWith("/auth/social/");
  authorize();

  if (CONFIG.ENV === "production") {
    LogRocket.init("rdcngf/oppizi");
  }

  const user = authorization.getUser();

  const overwriteGTMIfNeeded = async () => {
    const clientData = await getClient({ clientId: user?.clientId });
    const isEDDMSignup = clientData[0]?.createdBy === EDDM_SIGNUP;
    if (isEDDMSignup) {
      loadGTM("GTM-K535PLVV");
    }
  };

  overwriteGTMIfNeeded();

  if (authorization.isLogged() || isPublicRoute) {
    return children;
  } else {
    return <Login />;
  }
};

export default memo(Auth);
